import React, { createContext, useState } from "react";
import useFetch from "../../hooks/useFetch";

export const OrdersContext = createContext();
OrdersContext.displayName = "Sales List Context";

export const OrdersContextProvider = (props) => {
  const [orders, setOrders] = useState([]);
  const [maxPagination, setMaxPagination] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [latestQuery, setLatestQuery] = useState({});
  const [isLoadingOrders, setIsLoadingOrders] = useState(true);
  const { get, del } = useFetch();

  const getAllStatus = () => {
    return new Promise((resolve, reject) => {
      get("/orders/properties/status")
        .then(async (res) => {
          resolve(res);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const getOrders = (queries = latestQuery) => {
    setIsLoadingOrders(true);
    setLatestQuery(queries);
    let url = "/orders?";
    Object.keys(queries).map(function (key) {
      url += key + "=" + queries[key] + "&";
    });
    get(url)
      .then(async (res) => {
        setOrders(res.orders);
        setMaxPagination(res.total);
        setCurrentPage(Number(res.page));
        setIsLoadingOrders(false);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const deleteOrder = (orderId) => {
    return new Promise((resolve, reject) => {
      del(`/orders/${orderId}`)
        .then(async () => {
          resolve(true);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const setPagination = (page) => {
    let newQuery = { ...latestQuery };
    newQuery.page = page;
    getOrders(newQuery);
  };

  return (
    <OrdersContext.Provider
      value={{
        orders,
        maxPagination,
        currentPage,
        getOrders,
        getAllStatus,
        deleteOrder,
        setPagination,
        selectedOrders,
        setSelectedOrders,
        isLoadingOrders,
        latestQuery,
      }}
    >
      {props.children}
    </OrdersContext.Provider>
  );
};
